import {
  CANCEL_RESERVATION_START,
  CANCEL_RESERVATION_SUCCESS,
  CANCEL_RESERVATION_STATE_ERROR
} from '../../constants';
import history from '../../core/history';
import { decode } from '../../helpers/queryEncryption';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { cancelReservation as mutation } from '../../lib/graphql';

export const cancel = (
  reservationId,
  cancellationPolicy,
  refundToGuest,
  payoutToHost,
  guestServiceFee,
  hostServiceFee,
  total,
  currency,
  threadId,
  cancelledBy,
  message,
  checkIn,
  checkOut,
  guests,
  listTitle,
  confirmationCode,
  hostName,
  guestName,
  hostEmail,
  guestEmail,
  startTime,
  endTime,
  promoDiscount,
  promoCodeType
) => {
  return async (dispatch, getState, { client }) => {

    try {

      dispatch({
        type: CANCEL_RESERVATION_START,
      });

      const { data } = await client.mutate({
        mutation,
        variables: {
          reservationId,
          cancellationPolicy,
          refundToGuest: parseFloat(refundToGuest),
          payoutToHost: parseFloat(payoutToHost),
          guestServiceFee: parseFloat(guestServiceFee),
          hostServiceFee: parseFloat(hostServiceFee),
          total,
          currency,
          threadId,
          cancelledBy,
          message,
          checkIn,
          checkOut,
          guests,
          startTime,
          endTime,
          promoDiscount: parseFloat(promoDiscount),
          promoCodeType
        }
      });

      if (data?.cancelReservation?.status === '200') {
        dispatch({
          type: CANCEL_RESERVATION_SUCCESS,
        });

        if (cancelledBy === 'owner') {
          history.push('/reservation/current');
          showToaster({ messageId: 'reservationCancelled', toasterType: 'success' })
        } else {
          history.push('/trips/current');
          showToaster({ messageId: 'tripCancelled', toasterType: 'success' })
        }

      }

      if (data?.cancelReservation?.status === '400') {
        dispatch({
          type: CANCEL_RESERVATION_SUCCESS,
        });
        showToaster({ messageId: 'cancelReservationSuccess', toasterType: 'error' })
      }

    } catch (error) {
      dispatch({
        type: CANCEL_RESERVATION_STATE_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}